import {
  get,
  post
} from '../index'
export default {
  // 版权
  getCopyrightInfo () {
    return get('/card/Admin/getW7Tmp')
  },
  // 是否为微擎版，还是为独立版
  getIsWeiVersion () {
    return get('/agent/admin/isWe7')
  },
  // 微擎版免费版是否授权 (检查是否授权，1授权，0未授权)
  baseCheckAuth () {
    return get('/shortvideo/admin/checkAuth')
  },
  // 授权微擎免费版本
  baseGiveAuth (querys) {
    return get('/shortvideo/admin/giveAuth', querys)
  },
  // 退出登录
  userlogout () {
    return get('/agent/admin/unAuth')
  },
  // 获取订阅消息模版列表
  tmpList (querys) {
    return post('/publics/tmpl/AdminTmpl/tmpList', querys)
  },
  // 获取订阅消息模版列表
  tmpLists (querys) {
    return post('/publics/tmpl/AdminTmpl/tmpLists', querys)
  },
  // 自动同步模版ID
  getTmplId (querys) {
    return post('/publics/tmpl/AdminTmpl/getTmplId', querys)
  },
  // 保存订阅消息模版
  tmplUpdate (querys) {
    return post('/publics/tmpl/AdminTmpl/tmplUpdate', querys)
  },
  // 获取公司数据
  getBaseCompany (querys) {
    return post('/publics/someThing/getCompany', querys)
  },
  // 获取所有员工数据
  getBaseStaffInfo (querys) {
    return post('/publics/someThing/getStaffInfo', querys)
  },
  // 获取所有职位列表，默认返回全部，status:1查询已上架职位
  getBaseJobList (querys) {
    return post('/publics/SomeThing/jobList', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/base.js